import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { SpringRestoration } from '@app/models';

export const {
  initialState: springRestorationInitialState,
  selectors: springRestorationSelectors,
  facade: SpringRestorationFacadeBase,
} = buildState(SpringRestoration);

export function springRestorationReducer(
  state = springRestorationInitialState
): IEntityState<SpringRestoration> {
  return state;
}
